// *API Base URL
export const BASE_URL = process.env.REACT_APP_BASE_URL;

// *Image Base URL
export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

// *AES Key
export const AES_KEY = process.env.REACT_APP_AES_KEY;
export const AES_IV = process.env.REACT_APP_AES_IV;
